import * as React from 'react';
import { createPortal } from 'react-dom';

export const Portal = ({ children }: React.PropsWithChildren<{}>) => {
  const genplan = document.getElementById('genplan-svg');

  return createPortal(children, genplan as HTMLDivElement);
};
